import React from "react";
import "./footer.css";
import twitter from "../../Assets/Images/SocialMedia/x.svg"
import linkedIn from "../../Assets/Images/SocialMedia/linkedin.svg"
import youtube from "../../Assets/Images/SocialMedia/youtube.svg"

import Logo from "../../Assets/Images/Logos/logo.svg";
import {Link} from "react-router-dom";

export default class Footer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            footerProductList: [
                {
                    Name: "AI App Platform",
                    Route: "platform",
                    Icon: "",
                    Disabled: false,
                    isActive: false,
                },
                {
                    Name: "Solutions",
                    Route: "solutions/it",
                    Icon: "",
                    Disabled: false,
                    isActive: false,
                },
                {
                    Name: "AI App Store",
                    Route: "ai-app-store",
                    Icon: "",
                    Disabled: false,
                    isActive: false,
                },
                {
                    Name: "Resources",
                    Route: "resources/product-videos",
                    Icon: "",
                    Disabled: false,
                    isActive: false,
                },
            ],
            footerCompanyList: [
                {
                    Name: "Company",
                    Route: "company",
                    Icon: "",
                    Disabled: false,
                    isActive: false,
                },
                {
                    Name: "Contact",
                    Route: "company",
                    Icon: "",
                    Disabled: false,
                    isActive: false,
                },
                {
                    Name: "Terms and Conditions",
                    Route: "terms-and-conditions",
                    Icon: "",
                    Disabled: false,
                    isActive: false,
                },
                {
                    Name: "Privacy Policy",
                    Route: "privacy-policy",
                    Icon: "",
                    Disabled: true,
                    isActive: false,
                },
            ],
            newsLetterOnLoad: false,
            socialMediaList: [
                {
                    Name: 'LinkedIn',
                    Link: 'https://www.linkedin.com/company/ip-agent-ai/',
                    Icon: linkedIn
                },
                {
                    Name: 'Twitter',
                    Link: 'https://x.com/IpAgentAI4225',
                    Icon: twitter
                },
                {
                    Name: 'Youtube',
                    Link: 'https://www.youtube.com/@IPAgentAI',
                    Icon: youtube
                },

                // {
                //     Name: 'Facebook',
                //     Link: 'https://www.facebook.com/profile.php?id=61572394751678',
                //     Icon: facebook
                // },
            ],
        }
    }


    onChangeRoute = (activeMenu) => {
        this.setState({
            activeMenu
        })
        let {scrollToTop} = this.props;
        scrollToTop();
    }

    render() {
        let {socialMediaList, footerCompanyList} = this.state;
        let {scrollToTop} = this.props;
        return (
            <div className="footer-layout">
                <div className="footer">
                    <div className="footer-left-division">
                        <div className="footer-logo-division">
                            <Link to={"/"} className="footer-logo" onClick={scrollToTop}>
                                <img src={Logo}
                                     width={"100%"}
                                     alt={"IPAgent Logo"}/>
                            </Link>

                        </div>
                        <div className="footer-description">
                        </div>
                        <div className="footer-social-media-row">
                            {
                                socialMediaList.map(mediaList =>
                                    <a href={mediaList.Link}
                                       target={"_blank"}
                                       rel="noreferrer"
                                       aria-label={mediaList.Name} className='footer-contact-social-icon'
                                       key={mediaList.Icon}
                                       title={mediaList.Name}>
                                        <img src={mediaList.Icon} width={"20px"} alt={mediaList.Name}/>
                                    </a>
                                )
                            }
                        </div>

                    </div>
                    <div className="footer-right-division">
                        <div className="footer-category-section">
                            <div className="header-text footer-category-section-title">Navigation</div>
                            <div className="footer-category-section-body">
                                {
                                    footerCompanyList.map((nav, nid) =>
                                        <Link to={`/${nav.Route}`} className="footer-section-item footer-navigation"
                                              key={nid} onClick={scrollToTop}>
                                            {nav.Name}
                                        </Link>
                                    )
                                }
                            </div>
                        </div>
                        <div className="footer-category-section">
                            <div className="header-text footer-category-section-title">Contact Info</div>
                            <div className="footer-category-section-body">
                                <div className='footer-section-item address-item'>
                                    1 Rockefeller Plaza
                                </div>
                                <div className='footer-section-item address-item'>
                                    11th Floor PMB#8374
                                </div>
                                <div className='footer-section-item address-item'>
                                    New York NY 10020
                                </div>
                                {/*<div className='footer-section-item active address'>*/}
                                {/*+1 650-750-1000*/}
                                {/*</div>*/}
                                <div className='footer-section-item email-item'>

                                    <a className="email-link" href="mailto: chat@ipagent.ai">
                                        chat@ipagent.ai

                                    </a>
                                </div>

                            </div>
                        </div>
                        <div className="footer-category-section">
                            Copyright (C)2023 - 2025 IP Agent AI., Ltd. All right reserved
                            <br/>
                            <br/>
                            <div className="footer-credit-row">
                                Powered by <a href={"https://anygen.ai/"} target={"_blank"} rel="noreferrer">AnyGen
                                AI</a>
                            </div>
                        </div>

                    </div>
                </div>


            </div>
        );
    }
}